import type {
	MeasurementBulletinResponse,
	MeasurementBulletinRow,
	StageMeasurement,
	StageRollup,
} from "@/adapters/api";
import type { Bulletin, BulletinRow, Measurement, Rollup } from "../types.ts";

export function toMeasurement(item: StageMeasurement): Measurement {
	return {
		id: item.id,
		stageId: item.stage_id,
		stageName: item.stage_name,
		stageItemNumber: item.stage_item_number,
		measuredOn: item.measured_on.slice(0, 10),
		progressPercent: item.progress_percent,
		measuredCents: item.measured_cents,
		note: item.note,
		measuredByName: item.measured_by_name,
	};
}

export function byStageId(items: Measurement[]): Map<string, Measurement> {
	const latest = new Map<string, Measurement>();
	for (const item of items) {
		const current = latest.get(item.stageId);
		if (!current || current.measuredOn < item.measuredOn) {
			latest.set(item.stageId, item);
		}
	}
	return latest;
}

export function toRollup(item: StageRollup): Rollup {
	return {
		stageId: item.stage_id,
		percent: item.percent,
		measuredCents: item.measured_cents,
	};
}

export function rollupsByStageId(items: Rollup[]): Map<string, Rollup> {
	return new Map(items.map((item) => [item.stageId, item]));
}

function toBulletinRow(row: MeasurementBulletinRow): BulletinRow {
	return {
		stageId: row.stage_id,
		itemNumber: row.item_number,
		kind: row.kind,
		name: row.name,
		depth: row.depth,
		cancelled: row.cancelled,
		previousPercent: row.previous_percent,
		periodPercent: row.period_percent,
		accumulatedPercent: row.accumulated_percent,
		valueCents: row.value_cents,
		previousCents: row.previous_cents,
		periodCents: row.period_cents,
		accumulatedCents: row.accumulated_cents,
		remainingCents: row.remaining_cents,
		measuredOn: (row.measured_on ?? []).map((date) => date.slice(0, 10)),
	};
}

export function toBulletin(response: MeasurementBulletinResponse): Bulletin {
	return {
		from: response.from.slice(0, 10),
		to: response.to.slice(0, 10),
		valued: response.valued,
		rows: response.rows.map(toBulletinRow),
		totals: response.totals && {
			valueCents: response.totals.value_cents,
			previousCents: response.totals.previous_cents,
			periodCents: response.totals.period_cents,
			accumulatedCents: response.totals.accumulated_cents,
			remainingCents: response.totals.remaining_cents,
		},
		constructionName: response.construction.name,
	};
}
